export default __webpack_public_path__ + "static/media/greenArrow.896f2df9.svg";